import { defineComponent as _defineComponent } from 'vue'
import type { Instruction } from '@ilteducation/exercise-service-types';

type Props = {
  index: number;
  parentSource: string;
  resource: string;
  item: Instruction;
  preview: boolean;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'Reflection',
  props: {
    index: null,
    parentSource: null,
    resource: null,
    item: null,
    preview: { type: Boolean }
  },
  setup(__props: any) {



return { __sfc: true, }
}

})